import _ from 'lodash';
import React from 'react';
import i18next from 'i18next';
import CalculatorSelectInput from '../../../../calculatorInputs/CalculatorSelectInput';
import CalculatorStandardInput from '../../../../calculatorInputs/CalculatorStandardInput';

const EqualValue = ({ fieldName, showLabel, availableValueOptions, readOnly = false }) => {
  const label = showLabel ? i18next.t('calculator.dialog.create.label.values') : '';
  const selectPlaceholder = i18next.t('calculator.dialog.create.placeholder.selectValues');
  const inputPlaceholder = i18next.t('calculator.dialog.create.placeholder.indicateValue');

  const validate = () => {
    // TODO: custom validation if needed
    return null;
  };

  const commonProps = {
    fieldName: `${fieldName}.0`,
    label,
    isRequired: true,
    uxVariant: 'criteriaInput',
    variant: 'standard',
    validate,
  };

  return !_.isEmpty(availableValueOptions) ? (
    <CalculatorSelectInput
      {...commonProps}
      options={availableValueOptions}
      placeholder={selectPlaceholder}
      labelVariant="chip"
      triggerOnContinue
      disabled={readOnly}
    />
  ) : (
    <CalculatorStandardInput
      {...commonProps}
      placeholder={inputPlaceholder}
      triggerOnContinue
      disabled={readOnly}
    />
  );
};

export default EqualValue;
